module.exports = __webpack_public_path__ + "img/Hyatt-Regency-and-Lulu-Convention-Center.68069f87.jpg";